/**
 * Для нормальной работы обязательно должно быть свойство currentEntityKey
 */

import { eventBus } from '@/main'
import { mapGetters } from 'vuex'
import CloneDeep from 'lodash/cloneDeep'
const apiApplication = new ApplicationApi
import { debounce } from 'toolkit/utils/util'
import ApplicationApi from '@/api/applicationApi'
import axios from 'axios'

import NotificationApi from '@/api/notificationApi'
import Vue from 'vue'
const notif_api = new NotificationApi()

//const stPath = (process.env.VUE_APP_DOCKERMODE == '1' ? 'https://smarttender.biz/' : process.env.VUE_APP_GRAPHQL_PATH + '/')
const baseUrl = window.location.origin + window.config.BaseUrl

export default {
  data() {
    return {
      /* textFormatting: {
        italic: '_',
        bold: '*',
        strike: '~',
        underline: '°',
        multilineCode: '```',
        inlineCode: '`'
      }, */
      innerChatNotificationTypes: ['InnerChat', 'InnerChatAnswerMe'],
      //currentSubscription: {},
      entity: {
        entityId: null,
        entityType: null,
      },
      tags: [
        {
          key: 0,
          keyString: 'USER',
          hash: '@',
        },
        {
          key: 3,
          keyString: 'TENDER',
          hash: '###',
        },
        {
          key: 1,
          keyString: 'LOT',
          hash: '#',
        },
        {
          key: 2,
          keyString: 'BID',
          hash: '##',
        },
      ],
      status: {
        subscrible: 'SUBSCRIBE',
        unsubscrible: ' UNSUBSCRIBE',
        mute: 'MUTE',
        unmute: 'UNMUTE',
      }
    }
  },
  methods: {
    $_clickTag(clickParams) {
      let href
      switch (clickParams.type) {
      case 'lot': {
        href = `${baseUrl}/${this.$route.params.org}/tenders/${clickParams.params.tender}/${clickParams.params.lot}`
        break
      }
      case 'offer': {
        href = `${baseUrl}/${this.$route.params.org}/tenders/${clickParams.params.tender}?tab=offers`
        break
      }
      }
      window.open(href, '_blank').focus()
    },
    $_addNewInnerChatMessageToBell(model) {
      const newModel = []

      model.addedMesages.forEach((addedMesage) => {
        if (addedMesage.userLogin.toLowerCase() === this.user.login.toLowerCase()) { return }
        newModel.push({
          subscriptionEntityId: model.subscriptionEntityId,
          message: {
            timestamp: addedMesage.timestamp,
            messageId: addedMesage.id,
            messageType: 'AddInnerChatTenderMessage',
            viewed: addedMesage.isViewed,
            properties: [
              {
                key: 'Author',
                value: addedMesage.userLogin,
              },{
                key: 'Attachments',
                value: addedMesage.attachments,
              },{
                key: 'AuthorType',
                value: 'User'
              },{
                key: 'Comment',
                value: this.$_convertMessage(addedMesage, true)
              },{
                key: 'Tags',
                value: addedMesage.tags
              }
            ]}
        })
      })
      eventBus.$emit('newNotification', newModel)
    },
    $_checkMessageInViewPortAndChangeView(messages, mode) {
      return new Promise((resolve) => {
        // const ids = messages.filter(i => !i.isViewed).map(i => i.id)
        const notViewItems = messages.filter(i => !i.isViewed)
        if (notViewItems?.length) {
          const notView = []
          notViewItems.forEach((notViewItem) => {
            const block = document.getElementById(`inner-chat-${notViewItem.id}-${mode}`)
            if (this.$_isScrolledIntoView(block)) {
              notView.push(
                {
                  messageId: notViewItem.id,
                  messageType: 'InnerChat'
                }
              )
            }
          })
          if (notView?.length) {
            this.$_changeViewedMessages(notView)
          }
          resolve()
        } else {
          resolve()
        }
      })
    },
    $_sendMessageView_notify: debounce(async function (items) {
      await this.$store.dispatch('innerChat/setViewMessages_notify', {items})
    }, 250),
    $_sendMessageView: debounce(async function (model) {
      await this.$store.dispatch('innerChat/setViewMessages', {model})
    }, 250),
    $_changeViewedMessages(items) {
      if (!this.isActiveSignalR) {
        eventBus.$emit('ShowSignalAlert', 'Внутрішній чат. Зміна статусу повідомлення')
        return
      }
      Vue.prototype.$notifier.SendUpdateEventsStatuses({
        messages: items.map(
          item => ({
            messageId: item.messageId,
            eventType: item.messageType
          })),
      })
    },
    async $_sendNewMessage(messageObject) {
      if (!this.isActiveSignalR) {
        eventBus.$emit('ShowSignalAlert', 'Внутрішній чат. Відправка повідомлення')
        throw new Error('SignalR not active')
      }
      const checkExistInnerChat = (entity) => {
        return new Promise((resolve) => {
          if (this.$_getCurrentSubscription(entity)?.subscriptionEntityId) {
            resolve(this.$_getCurrentSubscription(entity).subscriptionEntityId)
            return
          }
          notif_api.updateSubscription({entity, status: this.status.subscrible}).then(async (result) => {
            const model = result.data.updateSubscription

            this.innerChat.subscriptionEntityId = model.subscriptionEntityId

            this.$store.dispatch('notification/setSubscriptions', {item: [model]})
            resolve(model.subscriptionEntityId)
          })
        })
      }
      await checkExistInnerChat(messageObject.entity)
        .then(async (chatKey) => {
          await this.$_formatMessageToSend(messageObject.messag)
            .then(async (messageResult) => {
              const messages = [messageResult]
              this.$notifier.InnerChatCreateMessages(chatKey, messages)
            })
            .catch((errors) => {
              this.$notice.warning({
                title: this.$t('Common.ErrorTitle'),
                message: this.$t(errors),
                showClose: true,
                progress: true,
                duration: 20
              })
              this.$log_error(errors)
              throw new Error(errors)
            })
        })
        .catch((errors) => {
          throw new Error(errors)
        })
    },
    /**
     * Получаем и заполняем внутренний чат по тендеру
     */
    $_getInnerChat: debounce(async function (subscribleEntity, first) {
      if (subscribleEntity.entityType == 'Tender' && subscribleEntity.entityId) {
        //const subscriptionEntityId = this.$_getCurrentSubscription(subscribleEntity)?.subscriptionEntityId
        //if (!subscriptionEntityId) { return }
        const props = {
          //subscriptionEntityId: subscriptionEntityId,
          entity: subscribleEntity,
          page: first ? 1 : Math.ceil((this.innerChat.messages?.length / 10) + 1),
          size: 10
        }

        apiApplication.getInnerChatMessage(props).then(async (response) => {
          if (response === null) { response = {} }
          response.messages = response?.messages || []
          response.messages = this.$_formatMessagesToView(response.messages)
          const newModel = CloneDeep(this.innerChat)
          newModel.subscriptionEntityId = this.$_getCurrentSubscription(subscribleEntity)?.subscriptionEntityId

          const existingMessagesMap = new Map()
          newModel.messages.forEach(message => {
            existingMessagesMap.set(message.id, message)
          })
          const filteredMessages = response.messages.filter(newMessage => {
            if (!existingMessagesMap.has(newMessage.id)) {
              existingMessagesMap.set(newMessage.id, newMessage)
              return true
            }
            return false
          })

          newModel.messages = first ? response.messages : [...newModel.messages, ...filteredMessages]

          newModel.unreadCount = response?.unreadCount > 0 ? response.unreadCount : 0
          newModel.messagesCount = response?.messagesCount || 0
          await this.$store.dispatch('innerChat/setModelInnerChat', {model: newModel})
        }).catch(async (error) => {
          const newModel = CloneDeep(this.innerChat)
          if (error.graphQLErrors?.[0]?.extensions.code === 'ChatDoesNotExist') {
            newModel.messages = []
            newModel.unreadCount = 0
            newModel.messagesCount = 0
          }
          await this.$store.dispatch('innerChat/setModelInnerChat', {model: newModel})
        })
          .finally(() => {
            eventBus.$emit('loadInnerChatFinish')
          })
      }
    }, 250),
    async $_formatMessageToSend(messageObject) {
      const files = await this.$_innerChatSendFiles(messageObject.files)
      if (messageObject?.files?.length !== files?.length) {
        throw new Error(this.$t('Tenders.FailedFileLoad'))
      }
      const fileIds = files.map(i => { return {attachmentId: i.id} })

      const tags = []
      if (messageObject.spr.userTag?.length) {
        const tagsOptions = this.tags.find(i => i.hash === '@')
        messageObject.spr.userTag.forEach((userTag) => {
          const key = `userTag-${userTag.contactId}`
          const tag = `@${userTag.name}`
          if (messageObject.value.indexOf(tag) !== -1) {
            messageObject.value = messageObject.value.replaceAll(tag, `*tag-${key}-tag*`)
            tags.push({
              key,
              value: JSON.stringify(userTag),
              type: tagsOptions.key // keyString
            })
          }
        })
      }
      if (messageObject.spr.hashTag?.length) {
        messageObject.spr.hashTag.sort((a, b) => b.hash.length - a.hash.length ).forEach((hashTag) => {

          const tagsOptions = this.tags.find(i => i.hash === hashTag.hash)
          const key = `hashTag-${hashTag.type}-${hashTag.id}`
          const tag = `${hashTag.hash}${hashTag.title}`

          if (messageObject.value.indexOf(tag) !== -1) {
            messageObject.value = messageObject.value.replaceAll(tag, `*tag-${key}-tag*`)
            tags.push({
              key,
              value: JSON.stringify(hashTag),
              type: tagsOptions.key
            })
          }
        })
      }
      return {
        parentMessageId: messageObject.parentMessageId,
        message: messageObject.value,
        tags,
        attachments: fileIds,
      }
    },
    async $_innderChatDownloadFiles(id, title) {
      if (!id) {
        return null
      }
      return await axios.get(
        `${window.config.GrapgQlUrl}/chat/attachment/${id}`,
        {
          headers: await apiApplication.getHeaders(),
          //onUploadProgress: listener,
          responseType: 'blob'
        }
      ).then((response) => {
        let url = URL.createObjectURL(response.data)
        let a = document.createElement('a')
        a.setAttribute('href', url)
        a.setAttribute('download', title)
        a.click()
      }).finally(() => this.loadInstruction = false)

    },
    async $_innerChatSendFiles(files) {
      if (!files?.length) {
        return []
      }

      const promises = files.map(async (file) => {
        const formData = new FormData()
        formData.append('files', file, encodeURI(file.name))
        try {
          const res = await axios.post(
            `${window.config.GrapgQlUrl}/chat/attachment`,
            formData,
            {
              headers: await apiApplication.getHeaders(),
            }
          )

          if (res.data.successed && res.data.returned?.length) {
            return res.data.returned[0]
          } else {
            return
          }
        } catch (_) {
          return
        }
      })

      try {
        const results = await Promise.all(promises)
        return results.filter(i => i)
      } catch (_) {
        return []
      }
    },
    /**
     * Форматируем сообщения для просмотра
     * @param {object} messages
     * @returns
     */
    $_formatMessagesToView(messages) {
      messages?.forEach(respons => {
        if (respons.attachments?.length) {
          respons.attachments.forEach(attachment => {
            attachment.fileName = decodeURI(attachment.fileName)
          })
        }
        respons.isMine = respons.userLogin?.toLowerCase() === this.user.login?.toLowerCase()
      })
      return messages
    },
    /**
     * Превращаем строку в HTML
     * @param {*} item
     * @returns
     */
    $_convertMessage(item, view = false) {
      let message = item.message || ''
      if (!message?.includes('-tag*')) {
        return message
      }
      const countTag = (message.match(/-tag*/g) || []).length

      const getTagItem = (tag) => {
        let tagType = 'span'
        const tagValue = JSON.parse(tag?.value || '')
        let props = ''
        const tagKey = this.tags.find(i => i.keyString.toLowerCase() === tag.type.toLowerCase())?.key

        let label = ''
        switch (tagKey) {
        case 0:
          props = `data-user="${tagValue.contactId}"`
          tagType = 'span'
          label = `${tagValue.hash}${tagValue.name}`
          break
        case 1:
          props = ` mode="click" type="lot" props_tender="${tagValue.tenderId}" props_lot="${tagValue.id}" `
          tagType = 'span'
          label = `${tagValue.hash}${tagValue.title}`
          break
        case 2:
          props = ` mode="click" type="offer" props_tender="${tagValue.tenderId}" props_offer="${tagValue.id}" `
          tagType = 'span'
          label = `${tagValue.hash}${tagValue.title}`
          break
        case 3:
          props = `href="${baseUrl}/${this.$route.params.org}/tenders/${tagValue.id}"`
          tagType = view ? 'span' : 'a'
          label = `${tagValue.hash}${tagValue.title}`
          break
        default:
          break
        }
        return `<${tagType} ${props}class="inner-chat-card_tag inner-chat-card_tag-${tagKey}">${label}</${tagType}>`
      }

      for (var i = 0; i < countTag; i++) {
        let startPosition = message.indexOf('*tag-')
        let endPosition = message.indexOf('-tag*') + 5
        const fistStringPart = message.substring(0, startPosition)
        const secondStringPart = message.substring(endPosition, message.length)
        const tagProps = message.substring(startPosition, endPosition)
        const tagKey = tagProps.replace('*tag-','').replace('-tag*','')

        const tag = item.tags.find(i => i.key === tagKey)

        if (tag) {
          message = `${fistStringPart}${getTagItem(tag)}${secondStringPart}`
        }
      }
      return message
    },
    /**
     * Наше сообщение отправлено успешно. Ставим статус
     * @param {*} value
     */
    $_setMessageState(value) {
      const index = this.innerChat.messages.indexOf(i => i.id === value[0].id)

      if (index === -1) {
        value[0].isMine = true
        value[0].isViewed = true
        this.$_addedNewMessageToModel({addedMesages: value})
        return
      }

      this.innerChat.messages[index].isMine = true
      this.innerChat.messages[index].isViewed = true
    },
    /**
     * Добавляем новое сообщение
     */
    $_addedNewMessageToModel: debounce(function (value) {
      const model = CloneDeep(this.innerChat)

      /* событие приходит только тем кто сидит на конкретной странице. */
      if (!model) { return }
      const exists = model.messages.indexOf(i => i.id === value.Messages.id)
      if (exists !== -1) {
        return
      }
      value.addedMesages = this.$_formatMessagesToView(value.addedMesages)

      model.messages = value.addedMesages.concat(model.messages)
      model.messagesCount = model.messages?.length
      model.unreadCount = model.messages?.filter(i => !i.isViewed)?.length || 0
      this.$store.dispatch('innerChat/setModelInnerChat', {model})
    }, 250),
    $_getCurrentSubscription(entity) {
      return this.subscriptions?.[entity?.entityType]?.[entity?.entityId] || {}
    },
  },
  computed: {
    ...mapGetters('notification', [ 'isActiveSignalR']),
    ...mapGetters({
      user: 'GET_USER',
      sprUsers: 'innerChat/sprUsers',
      /*sprUsersLoading: 'innerChat/sprUsersLoading',*/
      innerChat: 'innerChat/innerChat',
      sprHashItems: 'innerChat/sprHashItems',
      subscriptions: 'notification/subscriptions',
    }),
    $_currentSubscriptionKeys() {
      return {
        entityType: this.entityType || 'Tender',
        entityKey: this.currentEntityKey || this.tenderId
      }
    },
    currentSubscription: {
      get() {
        if (!this.subscriptions?.[this.$_currentSubscriptionKeys.entityType] || !this.$_currentSubscriptionKeys.entityKey) {
          return {}
        }
        return this.subscriptions?.[this.$_currentSubscriptionKeys.entityType]?.[this.$_currentSubscriptionKeys.entityKey] || {}//this.subscriptions?.Tender?.[this.tenderId?.toString()] || {}
      },
      set(newVakue) {
        this.$set(this.subscriptions[this.$_currentSubscriptionKeys.entityType], this.$_currentSubscriptionKeys.entityKey, newVakue)
      }
    },
    $_isMuted() {
      return this.currentSubscription?.muted === undefined || this.currentSubscription.muted
    },
    /* pseudoMarkdown() {
      return {
        [this.textFormatting.bold]: {
          end: '\\' + this.textFormatting.bold,
          allowed_chars: '.',
          type: 'bold'
        },
        [this.textFormatting.italic]: {
          end: this.textFormatting.italic,
          allowed_chars: '.',
          type: 'italic'
        },
        [this.textFormatting.strike]: {
          end: this.textFormatting.strike,
          allowed_chars: '.',
          type: 'strike'
        },
        [this.textFormatting.underline]: {
          end: this.textFormatting.underline,
          allowed_chars: '.',
          type: 'underline'
        },
        [this.textFormatting.multilineCode]: {
          end: this.textFormatting.multilineCode,
          allowed_chars: '(.|\n)',
          type: 'multiline-code'
        },
        [this.textFormatting.inlineCode]: {
          end: this.textFormatting.inlineCode,
          allowed_chars: '.',
          type: 'inline-code'
        }
      }
    } */
    $_muted() {
      return this.currentSubscription?.muted
    },
    $_existSubscription() {
      return !!this.currentSubscription?.subscriptionEntityId
    },
  },
  async mounted() {
    this.$root.$on('InnerChatCreateMessages', this.$_addedNewMessageToModel)
    this.$root.$on('InnerChatMessagesViewed', this.$_sendMessageView)
    this.$root.$on('UpdateEventsStatuses', this.$_sendMessageView_notify)

    await this.$store.dispatch('innerChat/getSprUser')
  },
  beforeDestroy() {
    this.$root.$off('InnerChatCreateMessages', this.$_addedNewMessageToModel)
    this.$root.$off('InnerChatMessagesViewed', this.$_sendMessageView)
    this.$root.$off('UpdateEventsStatuses', this.$_sendMessageView_notify)
  },
}
